import styled from 'styled-components';

type WrapperProps= {
    width: number;
}

export const Wrapper = styled.div<WrapperProps>`
  padding: 0 5px;
  .ui.search .prompt {
    border-radius: 5px;
    width: ${({ width }) => (width ? `${width}px` : '335px')};
    height: 36px;
  }

  .select-all {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text.default};
  }

  .search-result {
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .search-name {
      display: flex;
      align-items: center;
    }

    .ui.checkbox label:before {
      border-radius: 50%;
    }
    .ui.checkbox label:after {
      font-size: 12px;
      top: -4px;
    }

    .user-name {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.79;
      letter-spacing: 0.09px;
      color: ${({ theme }) => theme.colors.text.default};
      padding: 0 3px;
    }

    .user-info {
      font-size: 12px;
      text-align: right;
      color: ${({ theme }) => theme.colors.text.default};
    }
    img {
      padding: 0px 3px;
      height: 26px;
      width: 26px;
      border-radius: 50%;
    }
  }

  .ui.search > .results .result {
    padding: 4px 10px;
    border-bottom: unset;
  }

`;
